<template>
  <div v-if="productStore">
    <section v-if="productStore.is_product_loading">
      <TsLoadingCircularSpinner />
    </section>
    <section v-else-if="productStore.product
    && productStore.product.code">
     
      <TsBreadcrumb
          root-class="pt-2 mb-6 lg:my-4"
          :data="productStore.taxonomies"
      />
      <TsSection append-class="mb-0" container-class="px-0">
        <TsRow no-gutter append-class="items-start max-lg:flex-col gap-4">
          <div class="max-lg:w-full lg:sticky top-[130px]">
            <TsRow
                append-class="m-0 mb-2 justify-between"
                v-if="isMobile || isTablet"
            >
              <TsTypography append-class="mb-0 text-black" weight="semibold">

                <template v-if="productStore.product.brand">
                  {{ useTranslation("brand", "Merk:") }}
                  <NuxtLinkWithLocale
                      :data-testid="`brand-menu-link-to-brands-${productStore.product.brand.toLowerCase()}`"
                      :to="`/merk/${productStore.product.brand.toLowerCase()}`"
                      @click="logBrandVisit(productStore.product)"
                  >
                  <span class="hyperlink_text mr-2">
                    {{ productStore.product.brand }}
                  </span>
                  </NuxtLinkWithLocale>
                </template>

                <span
                    class="text-idle-black font-semibold mr-2"
                    :data-testid="`product-code${productStore.product.code}`"
                >
                {{useTranslation('id' , 'Productcode')}}:
                {{ productStore.product.code }}</span
                >
                <span v-if="productStore.product.pack_quantity" class="text-idle-black font-medium">
                   {{ /\d/.test(productStore.product.pack_quantity) ?  `| ${productStore.product.pack_quantity}` : '\u00A0' }}
                </span>
              </TsTypography>
            </TsRow>
            <div v-if="isMobile || isTablet">
              <TsTypography
                  as="h1"
                  variant="h2"
                  append-class="mb-2 text-idle-black leading-snug"
              >
              <span
                  class="font-normal"
                  :data-testid="`product-name-${productStore.product.name}-mobile`"
              >
                {{
                  productStore.builder_product_name ??
                  getLocaleName(productStore.product)
                }}</span
              >
              </TsTypography>
              <TsTypography
                  variant="sm"
                  as="div"
                  weight="semibold"
                  append-class="mb-3 flex items-center gap-2"
              >
              <span v-if="productStore.product_rating">{{
                  parseFloat(productStore.product_rating).toFixed(1)
                }}</span>
                <TsRatings
                :model-value="Number(productStore.product_rating)"
                />
                <template v-if="productStore.product_review_count">
                  <TsDivider layout="vertical" append-class="mx-0" />
                  <button
                      class="underline"
                      :data-testid="`pdp-${productStore.product.name}-rating`"
                      @click="onReviewTextClick"
                  >
                    {{ productStore.product_review_count }}
                    {{ useTranslation("ratings", "Beoordelingen") }}
                  </button>
                </template>
              </TsTypography>
            </div>

            <TsCarouselThumbnail
                :data-testid="`pdp-${productStore.product.name}-thumbnail`"
                :product="productStore.product"
                :data="
              productStore.builder_product_images?.length
                ? productStore.builder_product_images
                : productStore.product_images
            "
                :tags="productStore.promo_tags || []"
            />
          </div>
          <div class="grow max-lg:w-full">
            <TsRow append-class="m-0 mb-2 justify-between" v-if="isDesktop">
              <TsTypography append-class="mb-0" weight="semibold">
                <template v-if="productStore.product.brand">
                  {{ useTranslation("brand", "Merk") }}:
                  <NuxtLinkWithLocale
                      v-if="productStore.product.brand"
                      @click="logBrandVisit(productStore.product)"
                      :data-testid="`brand-menu-link-to-brands-${productStore.product.brand.toLowerCase()}`"
                      :to="`/merk/${productStore.product.brand.toLowerCase()}`"
                  >
                  <span class="hyperlink_text mr-2">
                    {{ productStore.product.brand }}
                  </span>
                  </NuxtLinkWithLocale>
                </template>
                <span class="text-idle-black font-medium mr-2">
                  {{useTranslation('id' , 'Productcode')}}:
                {{ productStore.product.code }}</span
                >
                <span v-if="productStore.product.pack_quantity" class="text-idle-black font-medium">
                  {{ /\d/.test(productStore.product.pack_quantity) ?  `| ${productStore.product.pack_quantity}` : '\u00A0' }}
                </span>
              </TsTypography>
            </TsRow>
            <div v-if="isDesktop">
              <TsTypography
                  as="h1"
                  variant="h2"
                  append-class="mb-2 text-idle-black leading-snug"
              >
              <span class="font-normal"  :data-testid="`product-name-${productStore.product.name}-desktop`">
                {{
                  productStore.builder_product_name ??
                  getLocaleName(productStore.product)
                }}
              </span>
              </TsTypography>
              <TsTypography
                  variant="sm"
                  weight="semibold"
                  append-class="mb-3 flex items-center gap-2 font-semibold"
              >
              <span
              v-if="productStore.product_rating"
              >{{
                  Number(parseFloat(productStore.product_rating).toFixed(1))
                }}
              </span>
                <TsRatings
                :model-value="Number(productStore.product_rating)"
                />
                <template v-if="productStore.product_review_count">
                  <TsDivider layout="vertical" append-class="mx-0" />
                  <p
                      @click="onReviewTextClick"
                      :data-testid="`pdp-${productStore.product.name}-rating`"
                      class="hyperlink_text"
                  >
                    {{ productStore.product_review_count }}
                    {{ useTranslation("reviews", "Recensies") }}
                  </p>
                </template>
              </TsTypography>
            </div>
            <TsTag
              v-if="monetateStore.social_proof_data"
              :label="monetateStore.social_proof_data"
              :size="isDesktop ? 'sm' : 'xs'"
              icon="oi:timer"
              append-class="mr-1"
              rounded
              variant="success"
            />
            <div
                class="mb-4 md:mb-5"
                v-if="productStore.product && productStore.product.variations
                 && productStore.product.variations.length"
            >
            <TsDivider/>
              <label
                  for=""
                  class="flex gap-2 font-medium text-idle-black pb-1 max-w-max"
              >
                {{
                  useTranslation(
                      "PDP-SelectProductVariant",
                      "Select Product Variant"
                  )
                }}
                <p v-if="productStore.is_product_variation_loading">0</p>
                <p v-else>({{ productStore.variation_dropdown?.length }})</p>
              </label>
              <TsSelectBox
                  v-if="productStore.variation_dropdown"
                  :dataTestid="`pdp-${productStore.product.name}-variations`"
                  append-class="lg:w-[80%]"
                  v-model="selectedVariation"
                  :options="productStore.variation_dropdown"
                  optionLabel="name"
                  :placeholder="
                getLocaleName(productStore.product) ||
                productStore.product.code
              "
                  @select="handleVariantSelection"
              />
            </div>

            <div>
              <div class="max-lg:w-full">
                <div class="mb-3">
                  <div class="flex justify-between items-end">
                    <div>
                      <TsTypography
                          variant="sm"
                          as="span"
                          weight="semibold"
                          append-class="mb-0 leading-tight"
                          v-if="
                        productStore.product.prices &&
                        productStore.product.prices.raw &&
                        productStore.product.prices.raw?.gross &&
                        productStore.product.prices.was_price_raw &&
                        productStore.product.prices.raw.gross <
                          productStore.product.prices.was_price_raw
                      "
                      >
                      <span class="line-through">
                        {{
                          rootStore.isIncVat
                              ? productStore.product.prices.was_price_formatted
                              : productStore.product.prices.was_price_net_formatted
                        }}</span>
                      </TsTypography>
                      <div class="flex justify-between gap-1 items-center">
                        <TsTypography
                            variant="h2"
                            append-class="leading-tight mb-0"
                        >
                        <span :data-testid="`${rootStore.isIncVat}-price`">
                          {{
                            rootStore.isIncVat
                                ? productStore.product?.prices?.formatted.gross
                                : productStore.product?.prices?.formatted.net
                          }}</span
                        >
                        </TsTypography>
                      </div>
                      <TsTypography
                          v-if="rootStore.isIncVat"
                          append-class="leading-tight"
                          data-testid="excl-vat-price"
                      >
                        Excl. {{ useTranslation("vat", "btw") }}
                        {{ productStore.product?.prices?.formatted.net }}
                      </TsTypography>
                      <TsTypography
                          v-else
                          append-class="leading-tight"
                          data-testid="inc-vat-price"
                      >
                        Incl. {{ useTranslation("vat", "btw") }}
                        {{ productStore.product?.prices?.formatted.gross }}
                      </TsTypography>
                    </div>

                    <div
                        v-if="productStore.promo_messages !== null"
                        class="flex flex-col"
                    >
                      <TsButtonGroup
                          :append-class="
                        twMerge(
                          'ml-auto transition-all duration-500',
                          promotion_card_toggle &&
                            'last:*:rounded-br-none first:*:rounded-bl-none'
                        )
                      "
                      >
                        <TsTag
                            append-class="bg-primary-yellow text-natural-black"
                        >
                          {{useTranslation("promotions" , "Promoties")}}
                        </TsTag>
                        <TsButton
                            icon="flowbite:angle-down-outline"
                            :data-testid="`pdp-${productStore.product.name}-promotion-card-toggle`"
                            @click="promotion_card_toggle = !promotion_card_toggle"
                            append-class="text-natural-black bg-warning-dark hover:bg-warning-dark border-warning-dark focus:ring-0 px-1 transition-all border-0"
                            :icon-class="
                          twMerge(
                            'transition-all duration-300',
                            promotion_card_toggle && 'rotate-180'
                          )
                        "
                            size="sm"
                        />
                      </TsButtonGroup>
                    </div>
                  </div>
                  <div
                      :class="
                    twJoin(
                      'transition-[height] duration-500 h-0 z-10 overflow-hidden',
                      promotion_card_toggle && 'h-auto'
                    )
                  "
                  >
                    <TsCard
                        v-if="productStore.promo_messages !== null"
                        data-testid="product-promo-message-card"
                        append-class="rounded-tr-none duration-500 mb-2 p-2.5"
                        no-shadow
                        no-border
                    >
                      <div
                          v-html="productStore.promo_messages[0]"
                          class="leading-tight [&>a]:text-primary [&>a]:font-semibold text-idle-black"
                      />
                    </TsCard>
                  </div>
                </div>
                <div class="mb-4">
                  <TsTypography variant="h3" append-class="mb-0">{{
                      useTranslation("quantity", "Hoeveelheid")
                    }}</TsTypography>
                  <TsQuantityCounter
                      :data-testid="`pdp-${productStore.product.name}-quantity-counter`"
                      v-model="productStore.quantity_to_add"
                      @increment="logIncrement"
                      @decrement="logIncrement"
                  />
                </div>
              </div>
            </div>
            <div
                :data-testid="`pdp-${productStore.product.name}-trolley-cta-section`"
                ref="intersectionTarget"
                class="btn-addtocart btn-default videoly-atc-btn"
            >
              <TsColumn
                  v-if="productStore.show_notify_me_cta"
                  append-class="mb-4 md:is-8"
              >
                <TsButton
                    v-if="isSubscribedToStock"
                    icon="material-symbols:unsubscribe-outline"
                    :label= "useTranslation('unsubscribeFromStockNotification' , 'Afmelden voor voorraadmeldingen')"
                    :is-loading="isStockUnsubscribeCTAloading"
                    @click="handleStockUnsubscribe(productStore.product?.code)"
                    append-class="whitespace-nowrap md:max-w-96 px-2.5 gap-1.5"
                    size="sm"
                    block
                    data-testid="stock-unsubscribe-cta"
                    outlined
                />
                <TsButton
                    v-else
                    :data-testid="`pdp-${productStore.product.name}-notify`"
                    block
                    icon="mdi:bell-outline"
                    :label="useTranslation('notifyMe','Breng mij op de hoogte')"
                    append-class="whitespace-nowrap"
                    @click="handleNotifyMe"
                />
              </TsColumn>

              <div
                  v-else-if="showCollectionDeliveryCTA"
                  class="mb-4"
              >
                <div v-if="showCollectionOption" class="mb-6">
                  <TsPdpCollectionAction
                      block
                      :icon="clickAndCollectIcon"
                      append-class="mb-2 md:max-w-96"
                      @collect="clickAndCollect"
                  />
                  <client-only>
                    <div v-if="!productStore.is_product_stock_loading">
                      <TsTypography
                          variant="sm"
                          append-class="mb-0 leading-[16px]"
                      >
                      <span v-if="enableNextDayCollection">
                        <span>
                          {{ getFormattedValue(Number(productStore.delivery_stock)) }}
                          {{ useTranslation('pdp-stockAvailableNextDatCollection', 'voorraad beschikbaar voor afhaling de volgende dag')  }}.
                        </span>
                        <span class="hyperlink_text" @click="openNextDayCollectionInfoModal">
                          {{ useTranslation("Read More", "Lees meer") }}
                        </span><br>
                        <span v-html="useTranslation(nextDayCollTranslationObject.key, nextDayCollTranslationObject.fallback)" />
                        {{ useTranslation("at", "in") }}
                        <span class="hyperlink_text" @click="expandStoreInfo">{{ branchStore.lastSavedBranch?.name }}</span>
                      </span>
                        <span v-else-if="branchStore.is_branch_set">
                        <span>
                          {{ getFormattedValue(Number(productStore.collection_stock)) }}
                          {{ useTranslation('pdp-stockAvailableCollection', 'op voorraad voor Click & Collect') }}
                        </span><br>
                        <span class="mt-1" v-html="useTranslation(clickAndCollectTranslationObject.key, clickAndCollectTranslationObject.fallback)" />
                        {{ ' ' }}
                        <span v-if="branchStore.is_branch_set"> {{ useTranslation("at", "in") }}                        </span>
                        {{ '' }}
                        <span class="hyperlink_text" @click="expandStoreInfo">{{ branchStore.lastSavedBranch?.name }}</span>
                      </span>
                      </TsTypography>

                      <TsTypography
                          v-if="!branchStore.is_branch_set"
                          variant="sm"
                          as="span"
                          append-class="mb-0 leading-[16px]"
                      >
                    <span
                        :data-testid="`pdp-${productStore.product.name}-branch-stock`"
                        class="hyperlink_text"
                        @click="branchStore.branchSelectorModalVisible = true"
                    >{{ useTranslation("selectBranch", "Selecteer een vestiging") }}
                    </span>
                        {{useTranslation('toSeetheAvailableStock' , 'om de beschikbare voorraad bij jou in de buurt te zien')}}
                      </TsTypography>
                    </div>
                  </client-only>

                  <div
                      v-if="
                    show_store_info &&
                    branchStore.is_branch_set &&
                    productStore.show_store_info
                  "
                      class="my-2"
                  >
                    <div v-if="show_store_info" class="my-2">
                      <div
                          class="border p-4 bg-natural-soft-white rounded-md text-natural-grey"
                      >
                        <div v-if="branchStore.lastSavedBranch" class="flex gap-12 max-w-max">
                          <div :class="twJoin('flex gap-2', branchStore.lastSavedBranch?.opening_hours.length && 'w-1/2')">
                            <TsIcon
                                name="tdesign:location"
                                size="26"
                                class="shrink-0"
                            />
                            <div>
                              {{ branchStore.lastSavedBranch.address_text }}
                            </div>
                          </div>
                          <div
                              class="flex gap-2"
                              v-if="
                            branchStore.lastSavedBranch.opening_hours.length
                          "
                          >
                            <TsIcon
                                name="mdi:clock-outline"
                                size="26"
                                class="shrink-0"
                            />
                            <div class="flex flex-col space-y-2">
                              <div
                                  v-for="(opening_hours, index) in branchStore
                                .lastSavedBranch.opening_hours"
                                  :key="index"
                              >
                                {{ opening_hours }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <NuxtLinkWithLocale
                            :to="getBranchSlug(branchStore.lastSavedBranch?.name)"
                            data-testid="pdp-see-more-info-about-store-link"
                            class="cursor-pointer mt-5 text-primary font-semibold hover:underline"
                        >
                          {{useTranslation('seeMoreInformationAboutStore' , 'zie meer informatie over de winkel')}}
                        </NuxtLinkWithLocale>
                      </div>
                    </div>
                  </div>
                  <client-only>
                    <div class="my-1" v-if="branchStore.is_branch_set">
                      {{useTranslation('check' , 'Bekijk')}}
                      <span class="hyperlink_text" @click="productStore.findNearByStock">{{useTranslation("stock" , "voorraad")}}</span>
                      {{useTranslation('levelsInOtherStores' , 'niveaus in andere winkels')}}
                    </div>
                  </client-only>
                </div>
                <template v-if="showDeliveryOption">
                  <TsPdpDeliveryAction
                      :product-slug="productStore.product.slug"
                      block
                      icon="mdi:truck-delivery-outline"
                      append-class="mb-2 md:max-w-96"
                      :disabled="isDeliveryDisabled()"
                      @deliver="addToDelivery"
                  />

                  <TsTypography variant="sm" append-class="mb-0 leading-[16px]"
                  >{{
                      productStore.is_direct_ship
                          ? getFormattedValue(Number(productStore.directship_stock))
                          : getFormattedValue(Number(productStore.delivery_stock))
                    }}
                    {{
                      useTranslation(
                          "PDP-StockAvaliableFor",
                          "op Voorraad"
                      )
                    }}
                    {{
                      productStore.is_direct_ship
                          ? useTranslation("directship", "bij leverancier")
                          : useTranslation("PDP-delivery", "voor bezorgen")
                    }}
                  </TsTypography>

                  <span v-if="productStore.product?.direct_ship">
                    <TsTypography v-html="useTranslation('directshipEstimation', 'Dit product wordt binnen 3 werkdagen geleverd')" variant="sm" weight="semibold" append-class="mb-0 leading-relaxed"/>
                  </span>
                  <span v-else>
                    <TsTypography v-html="useTranslation(orderTranslationObject.key, orderTranslationObject.fallback)" variant="sm" append-class="mb-0 leading-relaxed"/>
                  </span>
                </template>

              </div>
              <TsSectionAddToTrolleyBuyNow
                  v-else-if="showAddToTrolleyBuyNowCTA"
                  v-model:channel="productStore.selected_trolley_channel"
                  class="mb-4"
                  :delivery-stock="
                (productStore.is_direct_ship
                  ? productStore.directship_stock
                  : productStore.delivery_stock) + ' ' + useTranslation('availableForDelivery','Beschikbaar voor bezorging')
              "
                  :is-out-of-stock-for-delivery="productStore.is_direct_ship ? productStore.isOutOfStockForDelivery : productStore.isOutOfStockForDirectship"
                  :branch-name="branchStore.lastSavedBranch?.name"
                  :is-direct-ship="productStore.is_direct_ship"
                  :collection-availability="productStore.collectionAvailability"
                  :data-testid="`product-${productStore.product.code}-detail`"
                  :add-to-trolley-disabled="productStore.isTrolleyCTADisabled"
                  :buy-now-disabled="productStore.isTrolleyCTADisabled"
                  @set-branch="branchStore.branchSelectorModalVisible = true"
                  @find-stock="productStore.findNearByStock"
                  @add-to-trolley="
                (selectedTrolleyChannel) =>
                  onAddToTrolleyAction(selectedTrolleyChannel)
              "
                  @buy-now="
                (selectedTrolleyChannel) =>
                  onBuyNowAction(selectedTrolleyChannel)
              "
              />
            </div>
            <template v-if=" getKeyFeatures && getKeyFeatures?.length > 0">
              <TsTypography variant="h3" append-class="mb-0 mt-4">
                {{useTranslation("PDP-keyFeature","Belangrijkste kenmerken en details") }}
              </TsTypography>

              <TsTypography as="ul" append-class="list-disc ml-5">
                <TsTypography as="li" append-class="mb-0" v-for="(item, index) in getKeyFeatures" :key="index">
                  {{ item }}
                </TsTypography>
              </TsTypography>
            </template>
          </div>
        </TsRow>

        <div id="videoly-product-title" style="display:none;">{{ productStore.product.full_name ||productStore.product?.name }}</div> 
        <div id="videoly-product-id" style="display:none;">{{ productStore.product_id }}</div> 
        <div id="videoly-product-sku" style="display:none;">{{ productStore.product_id }}</div>
        <div id="videoly-category-tree" style="display:none;">{{ productStore.product?.taxonomies[0] }}</div>
        <div id="videoly-product-brand" style="display:none;">{{ productStore.product?.brand || null }} </div>
        <div id="videoly-product-price" style="display:none;">{{ productStore.product?.prices?.formatted.net }}</div>
        <div id="videoly-videobox-placeholder"></div>
      </TsSection>
      
      <TsContent model="symbol" path="/symbol/pdp-hifivesection" />
      
      <div class="pdp-description videoly-product-description">
      <TsSection container-class="px-0">
        <TsAccordion
            v-if="productStore.builder_product || isProductDescriptionAvailable"
            :data-testid="`product_description-${productStore.product.name}`"
            append-class="bg-white border border-grey rounded-lg overflow-hidden shadow-[3px_4px_16px_-5px_#001A331F]"
        >
          <TsAccordionTab
              data-testid="product_description_tab"
              append-class="bg-white text-lg font-semibold border-0 first:border-t-0 py-4 lg:px-5"
              body-class="border-t border-b-0 py-4 mx-3 px-0 lg:mx-5"
              :heading="useTranslation('productDescription', 'Productbeschrijving')"
              active
              @clickTab="
            (isOpen) => logDescriptionAccordionClick(isOpen, 'product_description')
          "
          >
            <div class="ts-content">
              <TsContentStatic
                  v-if="productStore.builder_product"
                  model="products"
                  :content="productStore.builder_product"
              />
            </div>
            <div v-if="getDetailedDescription">
              <p v-html="parseDescription(getDetailedDescription)"></p>
            </div>
            <div v-else-if="productStore.product.description?.length">
              <p v-html="parseDescription(productStore.product.description)"></p>
            </div>
          </TsAccordionTab>
        </TsAccordion>
       
        <TsAccordion
            :data-testid="`technical_specification-${productStore.product.name}`"
            append-class="bg-white border border-grey rounded-lg overflow-hidden shadow-[3px_4px_16px_-5px_#001A331F]"
        >
          <TsAccordionTab
              data-testid="technical_specification_tab"
              append-class="bg-white text-lg font-semibold border-0 first:border-t-0 py-4 lg:px-5"
              body-class="border-t border-b-0 py-4 mx-4 px-0 lg:mx-5"
              :heading="useTranslation('technicalSpecification', 'Technische specificatie')"
              active
              @clickTab="(isOpen) => logDescriptionAccordionClick(isOpen, 'technical_specification')"
          >
            <TsRow v-if="isDesktop">
              <TsColumn>
                <div
                    class="border border-grey overflow-hidden overflow-x-auto rounded-lg"
                >
                  <table
                      class="w-full border-hidden text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 pdp-description bg-white videoly-product-specifications"
                  >
                    <tbody class="border rounded overflow-hidden">
                    <tr
                        class="odd:bg-white odd:dark:bg-gray-900 even:bg-[#EDEDED] border-b"
                        v-for="item in productStore.product.technical_spec_attributes?.slice(
                        0,
                        Math.ceil(
                          productStore.product.technical_spec_attributes
                            ?.length / 2
                        )
                      )"
                    >
                      <th
                          scope="row"
                          class="rounded border-r border-natural-light-grey px-6 py-4 font-semibold text-gray-900 whitespace-nowrap"
                      >
                      {{ translations[item.id] || item.key }}
                      </th>
                      <td v-if="item.key === 'Product Manual'" class="border border-[#e5e7eb]">
                        <TsButton
                            class="px-6 py-4 rounded"
                            @click="openProductManual(item.value)"
                            label="Download PDF"
                        />
                      </td>
                      <td v-else-if="item.key === 'Safety Data Sheet'" class="px-6 py-4 rounded border border-[#e5e7eb]">
                        <NuxtLinkLocale
                          :to="item.value"
                          target="_blank"
                          rel="noopener noreferrer"
                          class="text-blue-500 underline hover:text-blue-700"
                        >
                        {{useTranslation("readMore", "Lees meer")}}
                        </NuxtLinkLocale>
                      </td>

                      <td v-else-if="item.id === 54" class="px-6 py-4 rounded border border-[#e5e7eb]">
                        <TsButton
                            v-if="isWarrentyRedirect(item.value)"
                            @click="
                            openProductManual(
                              separateLinkAndText(item.value)?.link
                            )
                          "
                            :label="separateLinkAndText(item.value)?.text"
                        />
                        <div v-else>{{ item.value }}</div>
                      </td>
                      <td v-else class="px-6 py-4 rounded border border-[#e5e7eb]">
                        {{ item.value }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </TsColumn>
              <TsColumn>
                <div
                    class="border border-grey overflow-hidden overflow-x-auto rounded-lg"
                >
                  <table
                      class="w-full border-hidden text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 pdp-description bg-white videoly-product-specifications"
                  >
                    <tbody class="border rounded overflow-hidden">
                    <tr
                        class="odd:bg-white odd:dark:bg-gray-900 even:bg-[#EDEDED] border-b"
                        v-for="item in productStore.product.technical_spec_attributes?.slice(
                        Math.ceil(
                          productStore.product.technical_spec_attributes
                            .length / 2
                        )
                      )"
                    >
                      <th
                          scope="row"
                          class="rounded border-r border-natural-light-grey px-6 py-4 font-semibold text-gray-900 whitespace-nowrap"
                      >
                      {{ translations[item.id] || item.key }}
                      </th>
                      <td v-if="item.key === 'Product Manual'" class="border border-[#e5e7eb]">
                        <TsButton
                            class="px-6 py-4 rounded"
                            size="sm"
                            @click="openProductManual(item.value)"
                            label="Download PDF"
                        />
                      </td>
                      <td v-else-if="item.key === 'Safety Data Sheet'" class="px-6 py-4 rounded border border-[#e5e7eb]">
                        <NuxtLinkLocale
                          :to="item.value"
                          target="_blank"
                          rel="noopener noreferrer"
                          class="text-blue-500 underline hover:text-blue-700"
                        >
                        {{useTranslation("readMore", "Lees meer")}}
                        </NuxtLinkLocale>
                      </td>
                      <td v-else-if="item.id === 54" class="px-6 py-4 rounded border border-[#e5e7eb]">
                        <TsButton
                            v-if="isWarrentyRedirect(item.value)"
                            @click="
                            openProductManual(
                              separateLinkAndText(item.value)?.link
                            )
                          "
                            :label="separateLinkAndText(item.value)?.text"
                        />
                        <div v-else>{{ item.value }}</div>
                      </td>

                      <td v-else class="px-6 py-4 rounded border border-[#e5e7eb]">
                        {{ item.value }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </TsColumn>
            </TsRow>
            <div
             class="border border-grey overflow-hidden rounded-lg"
              v-if="isMobile || isTablet"
              >
  <table
   class="w-full border-hidden text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 pdp-description videoly-product-specifications table-fixed">
    <thead>
      <tr>
        <th scope="col" class="px-6 py-3 w-[40%] border border-[#e5e7eb]">
          {{ useTranslation("product", "Product") }}
        </th>
        <th scope="col" class="px-6 py-3 w-[60%] border border-[#e5e7eb]">
          {{ useTranslation("detail", "Detail") }}
        </th>
      </tr>
    </thead>
    <tbody class="border rounded overflow-hidden">
      <tr
        class="odd:bg-white odd:dark:bg-gray-900 even:bg-[#EDEDED] border-b"
        v-for="item in productStore.product.technical_spec_attributes"
      >
        <th
          scope="row"
          class="rounded border-r border-natural-light-grey px-6 py-4 font-semibold text-gray-900 break-words"
        >
        {{ translations[item.id] || item.key }}
        </th>
        <td
          v-if="item.key === 'Product Manual'"
          class="px-6 py-4 rounded border border-[#e5e7eb]"
        >
          <TsButton
            @click="openProductManual(item.value)"
            label="Download PDF"
          />
        </td>
        <td v-else-if="item.key === 'Safety Data Sheet'" class="px-6 py-4 rounded border border-[#e5e7eb]">
                        <NuxtLinkLocale
                          :to="item.value"
                          target="_blank"
                          rel="noopener noreferrer"
                          class="text-blue-500 underline hover:text-blue-700"
                        >
                        {{useTranslation("readMore", "Lees meer")}}
                        </NuxtLinkLocale>
                      </td>
        <td v-else-if="item.id === 54" class="px-6 py-4 rounded border border-[#e5e7eb]">
          <TsButton
            v-if="isWarrentyRedirect(item.value)"
            @click="
            openProductManual(separateLinkAndText(item.value)?.link)
            "
            :label="separateLinkAndText(item.value)?.text"
          />
          <div v-else class="break-words hyphens-auto">{{ item.value }}</div>
        </td>
        <td v-else class="px-6 py-4 rounded break-words hyphens-auto overflow-hidden border border-[#e5e7eb]">
          {{ item.value }}
        </td>
      </tr>
    </tbody>
  </table>
</div>         
          </TsAccordionTab>
        </TsAccordion>
      </TsSection>
      </div>

      <TsContent model="products-details" />

      <div ref="reviewSection">
        <TsCard
            v-if="bazaarvoiceStore.product_reviews.length"
            append-class="bg-white overflow-visible max-lg:p-0 my-10"
            no-shadow
            :no-border="!isDesktop"
        >
          <TsCard
              append-class="bg-white lg:bg-idle-white relative flex flex-col lg:flex-row justify-center p-0 lg:p-8"
              no-shadow
              no-border
          >
            <div
                class="flex flex-col items-center max-lg:bg-idle-white max-lg:rounded-lg max-lg:p-3"
            >
              <TsTypography as="h2" append-class="mb-0">{{
                  useTranslation("productReview", "Stukken in sets")
                }}</TsTypography>
              <div class="flex lg:flex-col items-center max-lg:py-2">
                <TsTypography 
                  v-if="bazaarvoiceStore.average_rating"
                    append-class="flex items-center justify-center mb-0"
                    as="h3"
                >
                <span>{{
                    parseFloat(bazaarvoiceStore.average_rating.toFixed(1))
                  }}</span>
                  <TsIcon
                      name="ic:round-star"
                      class="text-warning-dark"
                      size="36"
                  />
                </TsTypography>
                <TsDivider layout="vertical" v-if="!isDesktop" />
                <TsTypography size="sm">
                  {{ bazaarvoiceStore.total_reviews }} reviews
                </TsTypography>

              </div>
              <TsImage class="lg:mt-4" height="60" width="100" src="https://display.ugc.bazaarvoice.com/common/images/trustmark_icons/trustmark_nl.png" alt="BazaarvoiceLogo" loading="lazy"/>

            </div>
            <TsDivider :layout="isDesktop ? 'vertical' : 'horizontal'" />
            <div>
              <TsTypography as="h2">{{
                  useTranslation(
                      "averageCustomerRating",
                      "Gemiddelde klantbeoordelingen"
                  )
                }}</TsTypography>

              <div
                  class="w-full lg:min-w-[324px] lg:max-w-[324px]"
                  v-for="item in bazaarvoiceStore.secondary_ratings_averages"
              >
                <TsTypography
                    as="div"
                    size="sm"
                    weight="semibold"
                    append-class="flex mb-3 items-center justify-between"
                >
                  <span> {{ item.Label }} </span>
                  <div class="flex items-center gap-1">
                    <span>{{ parseFloat(item.AverageRating.toFixed(1)) }}</span>
                    <TsRatings
                    :model-value="item.AverageRating"
                    />
                  </div>
                </TsTypography>
              </div>
            </div>
          </TsCard>
          <TsDivider />
          <div class="-m-1">
            <TsCarouselV2
                append-class="px-0"
                prev-button-class="left-1.5"
                next-button-class="right-1.5"
                drag-free
                :navigation="isDesktop"
                :pagination="false"
            >
              <TsCarouselSlide
                  @click="reviewDrawerVisible = true"
                  v-for="item in bazaarvoiceStore.product_reviews"
                  :key="item.id"
                  append-class="p-1 flex-[0_0_calc(100%/1.1)] sm:flex-[0_0_calc(100%/3)] lg:flex-[0_0_calc(100%/4)]"
              >
                <TsCardProductReview
                    :userName="item.user_name"
                    :title="item.title"
                    :review="item.review"
                    :rating="item.rating"
                    :id="item.id"
                    :isRecommended="item.is_recommended"
                    :reviewDate="item.last_modified_time"
                    :location="item.user_location"
                    :productName="item.original_product_name"
                    :images="mapImages(item.photos)"
                />
              </TsCarouselSlide>
            </TsCarouselV2>
          </div>
          <TsTypography
              @click="reviewDrawerVisible = true"
              variant="sm"
              weight="semibold"
              append-class="cursor-pointer mt-4 mb-0 text-info underline hover:no-underline max-w-max"
          >
            {{ useTranslation("seeMoreReviews", "Bekijk meer beoordelingen") }}
            ({{ bazaarvoiceStore.total_reviews }})
          </TsTypography>
          <ClientOnly>
            <Teleport to="body">
              <TsDrawer
                  append-class="is-12 md:is-5 z-[60] max-md:min-h-[100vh] overflow-x-hidden rounded-l-md p-0 overflow-y-auto"
                  position="right"
                  v-model:visible="reviewDrawerVisible"
              >
                <div
                    class="flex justify-between space-x-4 bg-[#F3F3F3] py-4 pl-4 md:pl-9 pr-4 sticky top-0 z-10 rounded-tl-md w-full"
                >
                  <TsTypography
                      weight="semibold"
                      :size="isMobile ? 'sm' : 'md'"
                      append-class="mb-0 text-idle-black leading-[17px]"
                  >
                    {{ productStore.product.brand }}
                    <span class="font-normal">
                    {{ productStore.product.name }}</span
                    >

                    <span class="text-idle-black font-semibold text-base">
                    ({{ productStore.product.code }})</span
                    >
                  </TsTypography>
                  <TsIcon
                      name="bitcoin-icons:cross-filled"
                      size="24"
                      class="shrink-0 cursor-pointer"
                      @click="reviewDrawerVisible = false"
                  />
                </div>
                <div class="px-4 md:px-9 py-3 md:py-6 bg-white">
                  <TsRow
                      append-class="border-b items-center border-b mb-1 md:mb-3"
                      no-gutter
                  >
                    <TsColumn>
                      <TsTypography
                          weight="semibold"
                          append-class="text-idle-black mb-1"
                      >
                        Reviews
                      </TsTypography>
                      <TsTypography
                          variant="sm"
                          append-class="mb-1 flex items-center"
                          weight="semibold"
                      >
                        <TsRatings
                        :model-value="bazaarvoiceStore.average_rating"
                        />
                        <span
                        >{{
                            parseFloat(
                                bazaarvoiceStore.average_rating.toFixed(1)
                            )
                          }}/5</span
                        >
                      </TsTypography>
                    </TsColumn>
                    <TsColumn v-if="!isMobile" append-class="text-right">
                    </TsColumn>
                  </TsRow>
                  <TsRow no-gutter class="justify-between items-center mb-4">
                    <TsTypography append-class="mb-0">
                      {{ bazaarvoiceStore.total_reviews }} reviews
                    </TsTypography>
                  </TsRow>
                  <div
                      class="max-w-md mb-4"
                      v-for="(item, index) in bazaarvoiceStore.rating_distribution"
                  >
                  <div class="flex items-center space-x-2 w-full">
                      <TsRatingBar 
                        append-class="w-full" 
                        :data-testid="`pdp-bazaarvoice-rating-bar-${index}`" 
                        :value="item.Count" 
                        :total="bazaarvoiceStore.total_reviews"
                      >
                        <template #label>
                          <span class="text-info w-2">
                            {{ item.RatingValue }}
                          </span>
                          <TsIcon name="ic:round-star" class="text-warning-dark" />
                        </template>
                      </TsRatingBar>
                      <span>
                        {{ item.Count }}
                      </span>
                    </div>
                  </div>
                  <TsCard 
                    v-if="bazaarvoiceStore.mapped_images.length"
                    append-class="bg-white rounded-md mb-2.5" 
                    noShadow 
                  >
                    <TsTypography
                        append-class="mb-3 text-idle-black"
                        weight="semibold"
                    >
                      Reviews with images
                    </TsTypography>
                    <div class="flex overflow-x-auto space-x-4">
                      <TsCarouselV2 append-class="w-[98%] mx-auto lg:px-0 px-0" :pagination="false">
                        <TsCarouselSlide
                          v-for="(image, index) in bazaarvoiceStore.mapped_images"
                          :key="image.id"
                          append-class="flex-[0_0_auto]"
                          @click="openImageModal(index)"
                        >
                          <TsImage
                            :src="image.image"
                            :alt="`reviews-${index}`"
                            width="102"
                            height="100"
                            class="rounded min-w-[102px]"
                            loading="lazy"
                          />
                        </TsCarouselSlide>
                      </TsCarouselV2>
                    </div>
                  </TsCard>
                  <TsSelectBox
                      append-class="mb-4 max-w-max"
                      :options="bazaarvoiceStore.filter_options"
                      v-model="selectedFilter"
                      optionLabel="name"
                      placeholder="Top Review"
                      @select="(e) => bazaarvoiceStore.setFilter(e.code)"
                  />
                  <div class="border-t pt-4">
                    <div class="space-y-2.5">
                      <TsCardProductReview
                          v-for="item in bazaarvoiceStore.product_reviews"
                          :key="item.id"
                          :userName="item.user_name"
                          :title="item.title"
                          :review="item.review"
                          :rating="item.rating"
                          :id="item.id"
                          :isRecommended="item.is_recommended"
                          :reviewDate="item.last_modified_time"
                          :location="item.user_location"
                          :productName="item.original_product_name"
                          :images="mapImages(item.photos)"
                          :productUrl="item.original_product_url"
                      />
                    </div>
                  </div>
                </div>
              </TsDrawer>
            </Teleport>
          </ClientOnly>
        <Teleport to="body">
          <TsModal v-model:visible="review_images_modal">
            <template #modal-content="{ modal }">
              <div class="relative">
                <TsIcon
                  @click="modal?.hide()"
                  class="cursor-pointer rounded-md hover:bg-gray-200 absolute top-0 right-0 m-4 z-10"
                  name="bitcoin-icons:cross-outline"
                />
              </div> 
              <div class="relative overflow-hidden w-full">  
                <div class="flex transition-transform duration-300">
                    <TsCarouselV2 
                        append-class="w-[98%] mx-auto lg:px-0 px-0" 
                        :pagination="false"
                        ref="modalCarouselRef"
                    >
                    <TsCarouselSlide
                      v-for="(image, index) in bazaarvoiceStore.mapped_images"
                      :key="image.id"
                      class="flex-[0_0_100%] justify-between items-center flex"
                    >
                      <TsImage
                        :src="image.desktopImage"
                        :alt="`reviews-${index}`"
                        width="400"
                        height="400"
                        class="min-w-[102px] m-auto"
                        loading="lazy"
                      />
                    </TsCarouselSlide>
                  </TsCarouselV2>
                </div>
              </div>
            </template>
          </TsModal>
        </Teleport>
        </TsCard>
      </div>

      <TsSection v-if="bazaarvoiceStore.question_answers.length">
        <TsFaqSection appendClass="bg-white mb-8">
          <template #header>
            <TsTypography
                appendClass="text-idle-black max-md:mb-0"
                variant="h3"
                align="left"
            >
              FAQ
            </TsTypography>
            <div
                class="flex max-md:flex-col md:items-center md:space-x-3 max-md:space-y-2"
            >
              <TsInputGroup append-class="lg:min-w-max">
                <TsInput
                    size="sm"
                    append-class="lg:w-96"
                    placeholder="Search question and answers"
                />
                <TsButton size="sm" icon="tabler:search" />
              </TsInputGroup>
              <div class="flex items-center max-lg:justify-between gap-2">
                <div class="flex items-center gap-2">
                  <TsTag size="sm">80 Questions</TsTag>
                  <TsTag size="sm">73 Answers</TsTag>
                </div>
                <TsTypography
                    append-class="mb-0 underline hover:no-underline text-info cursor-pointer"
                >
                  Ask a question
                </TsTypography>
              </div>
            </div>
          </template>
        </TsFaqSection>
      </TsSection>

      <!-- <TsSection  v-if="compare_product_id" container-class="px-0" append-class="pt-8 rounded-md pb-7">
        <TsTypography as="h2" append-class="text-idle-blak">
          {{
            useTranslation(
                "compareSimilarProduct",
                "Vergelijk met soortgelijke producten"
            )
          }}
        </TsTypography>
        <div class="lg:-mx-1.5">
          <TsCompareProductSectionPDP
              :navigation="!isMobile"
              data-testid="product-compare-carousel"
              :productIds="compare_product_id.toString()"
              slide-class="flex-[0_0_calc(100%/1.5)] sm:flex-[0_0_calc(100%/2.7)] md:flex-[0_0_calc(100%/3.5)] lg:flex-[0_0_calc(100%/5)]"
              :translations="translations"
          />
        </div>
      </TsSection> --> 
   <TsPdpRecommendations :productId="route.params.id"/>
      
      <TsContent model="symbol" path="/symbol/customer-support" />

      <!-- Causing late state update -->
       <!-- <Transition
          enter-from-class="opacity-0"
          enter-active-class="duration-300"
          leave-active-class="duration-300"
          leave-to-class="opacity-0"
      >  -->
        <TsNuxtCard
            v-if="!intersectionTargetVisible"
            :data-testid="`pdp-${productStore.product.name}-sticky-card-trolley-CTAs`"
            append-class="fixed bottom-0 w-full right-0 left-0 p-0 rounded-none shadow-[0px_-4px_15.6px_0px_#00000017] bg-white z-10 py-2"
        >
          <TsSection append-class="mb-0">
            <TsRow no-gutter class="justify-between items-center">
              <TsColumn>
                <TsTypography
                    v-if="!isMobile"
                    variant="h5"
                    append-class="text-idle-black leading-[30px]"
                >{{
                    productStore.builder_product_name ??
                    getLocaleName(productStore.product)
                  }}
                </TsTypography>
                <div class="flex flex-col md:flex-row md:items-end">
                  <TsTypography
                      variant="h3"
                      append-class="mb-0 leading-[28px] whitespace-nowrap text-success"
                      weight="bold"
                  >
                    {{
                      rootStore.isIncVat
                          ? productStore.product?.prices?.formatted.gross
                          : productStore.product?.prices?.formatted.net
                    }}
                  </TsTypography>

                  <TsTypography
                      v-if="rootStore.isIncVat"
                      as="span"
                      append-class="mb-0 md:ml-2 md:mb-1 text-xs sm:text-sm"
                  >
                    Excl. {{ useTranslation("vat", "btw") }}
                    {{ productStore.product?.prices?.formatted.net }}
                  </TsTypography>
                  <TsTypography
                      v-else
                      as="span"
                      weight="semibold"
                      append-class="mb-0 md:ml-2 md:mb-1 text-xs sm:text-sm"
                  >
                    Incl. {{ useTranslation("vat", "btw") }}
                    {{ productStore.product?.prices?.formatted.gross }}
                  </TsTypography>
                </div>
              </TsColumn>
              <TsColumn>
                <TsRow
                    class="justify-between md:justify-end space-x-3 md:space-x-8 items-center"
                    no-gutter
                >
                  <div v-if="productStore.show_notify_me_cta">
                    <TsButton
                        v-if="isSubscribedToStock"
                        icon="material-symbols:unsubscribe-outline"
                        :label="useTranslation('unsubscribeFromStockNotification' , 'Afmelden voor voorraadmeldingen')"
                        :is-loading="isStockUnsubscribeCTAloading"
                        @click="handleStockUnsubscribe(productStore.product?.code)"
                        append-class="whitespace-nowrap md:max-w-96 px-2.5 gap-1.5"
                        size="sm"
                        block
                        data-testid="stock-unsubscribe-cta"
                        outlined
                    />
                    <TsButton
                        v-else
                        :data-testid="`pdp-${productStore.product.name}-notify`"
                        block
                        icon="mdi:bell-outline"
                        :label="useTranslation('notifyMe','Breng mij op de hoogte')"
                        append-class="whitespace-nowrap"
                        @click="handleNotifyMe"
                    />
                  </div>

                  <div :class="`flex gap-2 ${showDeliveryOption && isMobile ? 'justify-end w-full' : 'justify-between'}`" v-else>
                    <template v-if="showCollectionDeliveryCTA">
                      <TsPdpCollectionAction 
                        v-if="showCollectionOption" 
                        :block="!isMobile" 
                        :icon="isMobile ? '' : clickAndCollectIcon"
                        append-class="whitespace-nowrap"
                        :size="isMobile ? 'xs' : 'md'"
                        is-sticky
                        @collect="clickAndCollect"
                      />
                      <TsPdpDeliveryAction 
                        v-if="showDeliveryOption"
                        :product-slug="productStore.product.slug"
                        :block="!isMobile"
                        :size="isMobile ? 'xs' : 'md'"
                        :icon="isMobile ? '' : 'mdi:truck-delivery-outline'"
                        append-class="whitespace-nowrap"
                        is-sticky
                        :disabled="isDeliveryDisabled()"
                        @deliver="addToDelivery"
                      />
                    </template>
                    <template
                        v-else-if="showAddToTrolleyBuyNowCTA"
                    >
                      <TsButton
                          icon="material-symbols:keyboard-double-arrow-right-rounded"
                          icon-class="size-6"
                          :label="useTranslation('buyNow', 'Koop Nu')"
                          :disabled="productStore.isTrolleyCTADisabled"
                          :data-testid="
                        'pdp-sticky-bottom-' +
                        productStore.product.name +
                        '-buy-now-cta'
                      "
                          append-class="whitespace-nowrap"
                          :size="isMobile ? 'xs' : 'md'"
                          :block="!isMobile"
                          @click="
                        onBuyNowAction(productStore.selected_trolley_channel)
                      "
                      />
                      <TsButton
                          icon="bx:cart"
                          :label="
                        useTranslation('addToTrolley', 'Toevoegen aan winkelwagen')
                      "
                          :disabled="productStore.isTrolleyCTADisabled"
                          :data-testid="
                        'pdp-sticky-bottom-' +
                        productStore.product.name +
                        '-add-to-trolley-cta'
                      "
                          append-class="whitespace-nowrap"
                          :size="isMobile ? 'xs' : 'md'"
                          :block="!isMobile"
                          @click="
                        onAddToTrolleyAction(
                          productStore.selected_trolley_channel
                        )
                      "
                      />
                    </template>
                  </div>
                </TsRow>
              </TsColumn>
            </TsRow>
          </TsSection>
        </TsNuxtCard>
      <!-- </Transition>  -->

      <div
          v-if="productStore.is_adding_to_trolley"
          class="h-screen w-screen inset-0 fixed bg-secondary-black/40 z-[100] grid place-items-center text-idle-black"
      >
        <TsIcon name="eos-icons:bubble-loading" size="40" />
      </div>

      <TsTrolleyConfirmationModal />
    </section>
  </div>
</template>

<script lang="ts" setup>
const TsPdpDeliveryAction = defineAsyncComponent(
    () => import('~/components/molecules/TsPdpDeliveryAction.vue')
);

const TsPdpCollectionAction = defineAsyncComponent(
    () => import('~/components/molecules/TsPdpCollectionAction.vue')
);

const TsLoadingCircularSpinner = defineAsyncComponent(
    () => import('~/components/organisms/TsLoadingCircularSpinner.vue')
);

const TsBreadcrumb = defineAsyncComponent(
    () => import('~/components/molecules/TsBreadcrumb.vue')
);

const TsCarouselThumbnail = defineAsyncComponent(
    () => import('~/components/organisms/TsCarouselThumbnail.vue')
);

const TsSection404 = defineAsyncComponent(
    () => import('~/components/organisms/TsSection404.vue')
);


const TsRatings = defineAsyncComponent(
    () => import('~/components/molecules/TsRatings.vue')
);  

const TsQuantityCounter = defineAsyncComponent(
    () => import('~/components/atoms/TsQuantityCounter.client.vue')
);

const TsSelectBox = defineAsyncComponent(
    () => import('~/components/atoms/TsSelectBox.vue')
);


const TsButtonGroup = defineAsyncComponent(
    () => import('~/components/molecules/TsButtonGroup.vue')
);


const TsCard = defineAsyncComponent(
    () => import('~/components/organisms/TsCard.vue')
);


const TsSectionAddToTrolleyBuyNow = defineAsyncComponent(
    () => import('~/components/organisms/TsSectionAddToTrolleyBuyNow.vue')
);


const TsAccordion = defineAsyncComponent(
    () => import('~/components/atoms/TsAccordion.vue')
);


const TsAccordionTab = defineAsyncComponent(
    () => import('~/components/atoms/TsAccordionTab.vue')
);



const  TsContentStatic = defineAsyncComponent(
    () => import('~/components/builder/TsContentStatic.vue')
);


const TsContent = defineAsyncComponent(
    () => import('~/components/builder/TsContent.vue')
);



const TsCarouselV2 = defineAsyncComponent(
    () => import('~/components/organisms/TsCarouselV2.vue')
);



const  TsCarouselSlide = defineAsyncComponent(
    () => import('~/components/organisms/TsCarouselSlide.vue')
);


const TsCardProductReview = defineAsyncComponent(
    () => import('~/components/organisms/TsCardProductReview.vue')
);  



const TsDrawer  = defineAsyncComponent(
    () => import('~/components/organisms/TsDrawer.vue')
);  


const TsRatingBar = defineAsyncComponent(
    () => import('~/components/molecules/TsRatingBar.vue')
);



const TsFaqSection = defineAsyncComponent(
    () => import('~/components/organisms/TsFaqSection.vue')
);



const TsInputGroup = defineAsyncComponent(
    () => import('~/components/molecules/TsInputGroup.vue')
);


/*
const TsCompareProductSectionPDP = defineAsyncComponent(
    () => import('~/components/organisms/TsCompareProductSectionPDP.vue')
);  
*/



const TsPdpRecommendations = defineAsyncComponent(
    () => import('~/components/organisms/TsPdpRecommendations.vue')
);

const TsNuxtCard = defineAsyncComponent(
    () => import('~/components/organisms/TsNuxtCard.vue')
);

const TsTrolleyConfirmationModal = defineAsyncComponent(
    () => import('~/components/organisms/TsTrolleyConfirmationModal.vue')
);


import { navigateTo } from "#app";
import { useTranslation } from "~/composables/useTranslation";
import { getBranchSlug } from "~/utils/navigation";
import { twJoin, twMerge } from "tailwind-merge";
import type { Product } from "~/types/ecom/product/product.type";
import { TrolleyChannel } from "~/types/ecom/trolley/trolley-map";
import { getOrderMessage, getClickAndCollMessage, getNextDayCollMessage } from "~/utils/formatMessage";
import { useAttributeTranslations } from "~/composables/useAttributeTranslation";
import { ProductAttributeMap } from "~/types/ecom/product/attribute-map";
import { getPDPDescription } from "~/utils/productAttributes";
import { OneTrustCookieGroup } from "~/assets/constants/cookie-consent";

definePageMeta({
  layout: "product",
  path: "/:slug/p:id(\\d+)",
});

const { translations } = useAttributeTranslations();  

const clickAndCollectTranslationObject = getClickAndCollMessage();
const nextDayCollTranslationObject = getNextDayCollMessage();
const orderTranslationObject = getOrderMessage();

const review_images_modal = ref(false);
const selected_image_index = ref(0);

const modalCarouselRef = ref(null);

function openImageModal(index: number) {
  selected_image_index.value = index;
  review_images_modal.value = true;
}

const {locale, locales} = useI18n();
const route = useRoute("slug-pid___nl-NL___default");
const router = useRouter();
const localePath = useLocalePath();
const trolleyStore = useTrolleyStore();
const productStore = useProductStore();
const rootStore = useRootStore();
const authStore = useAuthStore();
const accountStore = useAccountStore();
const bazaarvoiceStore = useBazaarvoiceStore();
const monetateStore = useMonetateStore();
const branchStore = useBranchStore();
const savelistStore = useSavelistStore();
const { trackPage } = useBazaarvoice();

const runtimeConfig = useRuntimeConfig();
const featureFlags = runtimeConfig.public.featureFlags;
const showCollectionDeliveryCTA = featureFlags.enableCTACollectionDelivery || featureFlags.enableSingleCTAinPLP;
const showAddToTrolleyBuyNowCTA = featureFlags.enableCTAAddToTrolleyBuyNow && !featureFlags.enableSingleCTAinPLP;

const promotion_card_toggle = ref(true);
const reviewDrawerVisible = ref(false);
const intersectionTarget = ref<HTMLElement | null>(null);
const reviewSection = ref<HTMLElement | null>(null);
// const compare_product_id = ref();
const intersectionTargetVisible = ref(false);
const selectedFilter = ref();
const selectedVariation = ref();
const isStockUnsubscribeCTAloading = ref(false);

let device = useDevice();

const isMobile = device.isMobile;
const isTablet = device.isTablet;
const isDesktop = device.isDesktop;
const trolleyConfirmationTimeoutID = ref<ReturnType<typeof setTimeout>>();

const getKeyFeatures = computed(()=> {
  const keyFeatures = productStore.product?.other_attributes?.find(attr => attr.key.toLowerCase() === ProductAttributeMap.KeyFeaturesPDP.toLowerCase());
  return keyFeatures ? getPDPDescription(keyFeatures.value) : null;
});

const getDetailedDescription = computed(()=> {
  const detailedDesc = productStore.product?.other_attributes?.find(attr => attr.key === ProductAttributeMap.DetailedDescriptionPDP);
  return detailedDesc ? detailedDesc.value : null;
});

function getFormattedValue(stock: number) {
  return stock > 50 ? '50+' : stock;
}

useHead(() => {
  // Extract title if data exists
  const seoTitle = productStore.builder_product?.data?.seoMetaTags?.title;
  const seoDescription = productStore.product?.attributes?.meta_description;
  const fallbackTitle = productStore.product?.attributes?.meta_title
    ? productStore.product.attributes?.meta_title
    : null;

  // Define head properties
  const headConfig: any = {
    title: seoTitle ?? fallbackTitle ?? productStore.product?.name, // Set title only if available
    meta:[{ name: "description", content: seoDescription ?? productStore.product?.description, },
      { name: "title", content: seoTitle ?? fallbackTitle ?? productStore.product?.name }, 
      { property: "og:title", content: seoTitle ?? fallbackTitle ?? productStore.product?.name, }, 
      { property: "og:description", content: seoDescription ?? productStore.product?.description }, ],
    script: [],
  };

  return headConfig;
});

const videolyScriptOptions: Partial<HTMLScriptElement> = {
    type: 'text/javascript', 
    innerHTML: `
      (function(d, e, n){
        e = d.createElement('script');
        e.type = 'text/javascript';
        e.src = '//api.videoly.co/1/quchbox/0/1028/quch.js';
        n = d.getElementsByTagName('script')[0];
        n.parentNode.insertBefore(e, n);
      })(document);
    `,
};

// Manually load the videoly script only if user has given cookie consent
const videolyScript = useScript(videolyScriptOptions, {
  trigger: "manual"
})

// Check if cookie consent is given to videoly (belongs to functional cookie group [C0003] - ref: UK)
if (rootStore.checkConsent(OneTrustCookieGroup.Functional)) {
  setTimeout(() => {
    videolyScript.load();
  }, 1000);
}

productStore.product_id = route.params.id;
bazaarvoiceStore.product_id = route.params.id;

const { data: product, pending, error } = await useLazyAsyncData(`product-${route.params.id}`, async () =>{
  const res = await productStore.fetchProductById(route.params.id, route)

  if(!res || !res.data || !res.data.code){
    let code = res && res.data && res.data.error && res.data.error.code ? res.data.error.code : process.server ? 404 : 500;
    let message = res && res.data && res.data.error && res.data.error.message ? res.data.error.message : process.server ? 'Product not found in server' : 'Something went wrong';
    showError({
      statusCode: code,
      statusMessage: message,
      data:res
    })
  }

  return res;
})


if(error.value){
  throw createError(error.value);
}


const { data:isProductStockFetchSuccessful } = await useAsyncData(`stock-${route.params.id}`,
  () => productStore.fetchProductStocks(route.params.id, true).then(() => true),
  {
  lazy:true,
  watch:[product]
})

await useAsyncData('variations', ()=> productStore.fetchProductVariations(locale.value,locales.value).then(() => true),{
    lazy: true,
    watch: [product]
});

// TODO: call this after new url is updated on Builder
// async function getBuilderProduct() {
//   await useAsyncData(
//       "builderProduct",
//       () => productStore.getBuilderProduct(route.fullPath).then(() => true),
//       {lazy: !!cachedBuilderProduct.value}
//   )
// }

if (productStore.product && !productStore.is_product_loading) {
  schemaPDP(productStore.product);
}

//------------------ PDP Utility functions
function mapImages(images: any[]) {
  return images.map((image) => image.Sizes.normal.Url);
}

const isProductDescriptionAvailable = computed(() =>
    productStore.product.description?.length > 0
    || (productStore.detailed_product_description.length > 0)
)

function parseDescription(str: string) {
  return str.replace(/\n/g, "<br>");
};

const isWarrentyRedirect = (input: string) => {
  const regex = /(https?:\/\/[^\s]+)/g; // Matches URLs starting with http:// or https://
  const match = input.match(regex);
  if (match) return true;
  else return false;
};

function separateLinkAndText(input: string) {
  // Use a regular expression to capture the URL and text
  const regex = /(https?:\/\/[^\s]+)/g; // Matches URLs starting with http:// or https://
  const match = input.match(regex);

  if (match) {
    // The link is found
    const link = match[0];
    // Replace the link from the string to get the text
    let text = input.replace(link, "").trim();
    if (!text) {
      text = "Click here";
    }
    return { link, text };
  } else {
    return null; // If no URL is found
  }
};

// Intersection Observer
const { stop: stopCTAInterSectionObserver } = useIntersectionObserver(
    intersectionTarget,
    ([{ isIntersecting }]) => {
      intersectionTargetVisible.value = isIntersecting;
    },
    {
      rootMargin: isDesktop ? "-10px" : "-50px",
    }
);

const headerHeight = isMobile ? 10 : 130;  

const onReviewTextClick = () => {
  if (reviewSection.value) {
    const yOffset =
        reviewSection.value.getBoundingClientRect().top +
        window.scrollY -
        headerHeight;
    window.scrollTo({ top: yOffset, behavior: "smooth" });
  }
};

const openProductManual = async (path: string) => {
  await navigateTo(path, {
    open: {
      target: "_blank",
    },
  });
};

const handleVariantSelection = async () => {
  await productStore.navigateToProductVariation(`${selectedVariation.value.code}`, `${selectedVariation.value.name}`);
  logEvent({
    options: {
      eventAction: "click",
      eventProperties: {
        product_name: selectedVariation.value.name,
        product_id: selectedVariation.value.code,
      },
      eventInteraction: true,
      eventLabel: `User clicked to change the Product variant to id ${selectedVariation.value.code} on product detail page`,
      eventName: "pdp_product_variants",
    },
  });
};

/* OOS Notification Actions - Start */
const isSubscribedToStock = computed(() => {
  if (!authStore.user || !authStore.user.id) return false;

  return accountStore.stock_notifications.some((notification: any) => {
    return notification.product_id === productStore.product?.code;
  });
});

const handleNotifyMe = () => {
  if (!authStore.is_authenticated) {
    navigateTo(localePath("/login"));
    return;
  }
  productStore.setProductCodeforNotification(
      productStore.product.code,
      productStore.product.name
  );
  productStore.subscribe_notification_modal_visible = true;
};

watch(review_images_modal, (isVisible) => {
  if (isVisible) {
    setTimeout(() => {
      if (modalCarouselRef.value?.emblaApi) {
        modalCarouselRef.value.emblaApi.scrollTo(selected_image_index.value);
      }
    }, 100);
  }
});

async function handleStockUnsubscribe(productCode: string) {
  isStockUnsubscribeCTAloading.value = true;
  try {
    await productStore.unSubscribeProduct(productCode, true);
    authStore.getStockNotifications();
  } catch (err) {
    const {customClientErrorHandler} = await import("~/services-optimized/customErrorService");

    const errorMeta = {
      code: productCode,
      loader: isStockUnsubscribeCTAloading.value,
      pdpError: true,
    }

    customClientErrorHandler(
        err,
        'high',
        'PDP Error - trying to unsubscribe stock using handleStockUnsubscribe()',
        errorMeta
    );
    rootStore.toastErrors(["Failed to unsubscribe. Try again"], "top-right");
  } finally {
    isStockUnsubscribeCTAloading.value = false;
  }
}
/* OOS Notification Actions - End */

//-------------------- TROLLEY ACTIONS START
const stopBranchWatcher = watch(
    () => branchStore.lastSavedBranch,
    (newBranch) => {
      if (!productStore.is_product_loading) {
        productStore.fetchProductStocks(route.params.id);
      }
      if (productStore.show_store_info) {
        router.push({
          path: route.path,
          query: { store: newBranch?.id },
        });
        productStore.store_info = branchStore.lastSavedBranch;
      }
    }
);

// To track out of stock conditions - @todo: merge with above branch watcher
watchEffect(() => {
  if (productStore.is_direct_ship) {
    productStore.show_notify_me_cta = productStore.isOutOfStockForDirectship && checkNotifyMeOption(productStore.product);
    return;
  }
  productStore.show_notify_me_cta =
      branchStore.is_branch_set &&
      productStore.collectionAvailability?.stock === 0 &&
      productStore.isOutOfStockForDelivery && checkNotifyMeOption(productStore.product);
    });
    
/* ----------------- V1 actions START ------------------ */
function isDeliveryDisabled() {
  if (productStore.is_product_stock_loading) return true;
  return productStore.is_direct_ship
    ? productStore.isOutOfStockForDirectship
    : productStore.isOutOfStockForDelivery;
}

async function addToDelivery() {
  productStore.delivery_method = "Delivery";
  if (productStore.is_direct_ship) {
    await addToDirectShip();
    return;
  }

  productStore.is_adding_to_trolley = true;

  await trolleyStore.addToTrolleyForDelivery(
      productStore.product.code,
      productStore.quantity_to_add,false
  );
  showConfirmationModal();
  logPdpBottomAddToCart(productStore.product)
}

async function addToDirectShip() {
  productStore.is_adding_to_trolley = true;
  productStore.delivery_method = "Directship";
  await trolleyStore.addToTrolleyForDirectship(
      productStore.product.code,
      productStore.quantity_to_add,false
  );
  showConfirmationModal();
}

function showConfirmationModal() {
  trolleyConfirmationTimeoutID.value = setTimeout(() => {
    productStore.is_adding_to_trolley = false;
    productStore.is_confirmation_modal_visible = true;
  }, 1000);
}

const showDeliveryOption = computed(() => productStore.product?.next_day_delivery || productStore.product?.direct_ship);

const showCollectionOption = computed(() =>
    productStore.product?.click_and_collect &&
    !productStore.product.direct_ship
);

const show_store_info = ref(false);
function expandStoreInfo() {
  show_store_info.value = !show_store_info.value;
}

const clickAndCollectIcon = computed(() => {
  if (enableNextDayCollection.value) {
    return "mdi:store-clock-outline";
  }
  return "mynaui:store";
});

const enableNextDayCollection = computed(() => {
  if (!branchStore.is_branch_set || productStore.is_product_stock_loading)
    return false;
  return (
      Number(productStore.quantity_to_add) >
      Number(productStore.collection_stock) &&
      Number(productStore.delivery_stock) > 0
  );
});

function openNextDayCollectionInfoModal() {
  productStore.isNextDayCollectionInfoModalVisible = true;
}

async function clickAndCollect() {
  // re-calculate stock only if branch is not set
  if (!branchStore.is_branch_set) {
    await branchStore.listenToBranchSet();
    await productStore.fetchProductStocks(route.params.id);
  }

  const availableDeliveryStock = Number(productStore.delivery_stock);
  const availableCollectionStock = Number(productStore.collection_stock);

  productStore.is_adding_to_trolley = true;

  let method = trolleyStore.addToTrolleyForCollection;
  productStore.delivery_method = "Collection";

  const isEligibleForNextDayCollection = checkItemForNextDayCollection({
    productCode: productStore.product.code,
    collectionStock: availableCollectionStock,
    quantityToAdd: productStore.quantity_to_add,
  });

  // if item already exists in trolley and more than available collection quantity is being added
  if (availableDeliveryStock > 0 && isEligibleForNextDayCollection) {
    method = trolleyStore.addToTrolleyForNextDayCollection;
    productStore.delivery_method = "NextDayCollection";
    logPPdpNextDayCollection(productStore.product);
  }

  await method(productStore.product.code, productStore.quantity_to_add,false);

  showConfirmationModal();
};


/* ----------------- V2 actions START ------------------ */
//--- Set initial trolley channel radio based on available stock
function setDefaultTrolleyChannel() {
  // set collection oos indicator
  const isProductOutOfStockForCollection =
      productStore.collectionAvailability?.status === "OutOfStock";
  // set delivery oos indicator
  const isProductOutOfStockForDelivery = productStore.is_direct_ship
      ? productStore.isOutOfStockForDirectship
      : productStore.isOutOfStockForDelivery;
  if (
      !isProductOutOfStockForCollection &&
      branchStore.is_branch_set &&
      isProductOutOfStockForDelivery
  )
    productStore.selected_trolley_channel = TrolleyChannel.Collection;
  else if (!isProductOutOfStockForDelivery)
    productStore.selected_trolley_channel = TrolleyChannel.Delivery;
  else productStore.selected_trolley_channel = null as any;
}

const onAddToTrolleyAction = async (selectedTrolleyChannel: TrolleyChannel) => {
  // Directship
  if (productStore.is_direct_ship) {
    await addToDirectShip();
  }

  // Next day collection
  else if (
      selectedTrolleyChannel === TrolleyChannel.Collection &&
      productStore.collectionAvailability?.status === "NextDayCollection"
  ) {
    productStore.is_adding_to_trolley = true;
    productStore.delivery_method = "NextDayCollection";
    await trolleyStore.addToTrolleyForNextDayCollection(
        productStore.product.code,
        productStore.quantity_to_add,false
    );
    showConfirmationModal();
  }

  // Collection
  else if (selectedTrolleyChannel === TrolleyChannel.Collection) {
    await clickAndCollect();
  }

  // Delivery
  else {
    await addToDelivery();
  }
};

const onBuyNowAction = async (selectedTrolleyChannel: TrolleyChannel) => {
  const checkoutStore = useCheckoutStore();
  productStore.is_adding_to_trolley = true;

  // Directship delivery
  if (productStore.is_direct_ship) {
    await checkoutStore.addToBuyNowForDirectship(
        productStore.product.code,
        productStore.quantity_to_add
    );
  }

  // Next day collection
  else if (
      selectedTrolleyChannel === TrolleyChannel.Collection &&
      productStore.collectionAvailability?.status === "NextDayCollection"
  ) {
    await checkoutStore.addToBuyNowForNextDayCollection(
        productStore.product.code,
        productStore.quantity_to_add
    );
  }

  // Collection
  else if (
      selectedTrolleyChannel === TrolleyChannel.Collection &&
      productStore.collectionAvailability?.status === "Collection"
  ) {
    await checkoutStore.addToBuyNowForCollection(
        productStore.product.code,
        productStore.quantity_to_add
    );
  }

  // Delivery
  else {
    await checkoutStore.addToBuyNowForDelivery(
        productStore.product.code,
        productStore.quantity_to_add
    );
  }

  productStore.is_adding_to_trolley = false;
  await navigateTo(localePath("/buy-now"));
};
//-------------------- TROLLEY ACTIONS END


function logIncrement() {
  logPdpProductQty(productStore.product,productStore.quantity_to_add)
 }

const logBrandVisit = (product: Product) => {
  logEvent({
    options: {
      eventAction: "click",
      eventProperties: {
        brand: product.brand,
        id: product.code,
        name: product.name,
      },
      eventInteraction: true,
      eventLabel: `User Navigate to Brand : ${product.name}`,
      eventName: "pdp_brand_link_clicks",
    },
  });
};

const logDescriptionAccordionClick = (isOpen: boolean, type: string) => {
  logDescriptionAccordionClicks(productStore.product,isOpen,type)
};

//-------------------- GTM LOGGER END

onBeforeUnmount(() => {
  if (reviewDrawerVisible.value && document && document.body && document.body.classList) {
   document.body.classList.remove('overflow-hidden') 
  }
})

onMounted(async() => {
  trackPage();

  bazaarvoiceStore.initialize();

  authStore.getStockNotifications();
  // getCompareProductIds();
  if(authStore.is_authenticated && !savelistStore.fetching_in_progress) savelistStore.getUserSaveLists();
  // checking store code in url
  if (route.query.store && route.query.store.length > 0) {
    productStore.showAdscenceStore(route.query.store as string);
  }
  nextTick(() => {
    if (showAddToTrolleyBuyNowCTA) setDefaultTrolleyChannel();

    //log out_of_stock
if(productStore.show_notify_me_cta===true&&productStore.product?.code) {logOutOfStock(productStore.product);}
  })
})

function getLocaleName(product) {

  return getProductLocaleName(product,locale.value,locales.value);

}

onUnmounted(() => {
  // productStore.$reset();
  productStore.is_confirmation_modal_visible = false;
  stopCTAInterSectionObserver();
  stopBranchWatcher();
  // stopCompareProductWatcher();
  if (trolleyConfirmationTimeoutID.value)
    clearTimeout(trolleyConfirmationTimeoutID.value);
  // monetateStore.pdp_recommended_products_ids = [];
  // monetateStore.pdp_related_compare_product_id = [];
});
</script>
